import React from 'react';

// import Swiper React components
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

// images
import testimonial_image_1 from '../../assets/images/testimonial-slide-img-2.png';
import testimonial_image_2 from '../../assets/images/testimonial-slide-img-1.png';
import testimonial_image_3 from '../../assets/images/testimonial-slide-img-3.png';

const TestimonialSlider = () => {

    const data = [
        {
            image: testimonial_image_1,
            testimony: '👩‍🦳 “Energy All Day—Without Jitters” Before Red Maca, I relied on 2–3 cups of coffee just to feel human—and then came the afternoon crash. With Red Maca, I feel awake, focused, and productive from morning to night. It’s a smooth kind of energy—no anxiety, no heart racing, just natural stamina that lasts.'
        },
        {
            image: testimonial_image_2,
            testimony: '🧘‍♀️ “My Mood? Way More Stable” I didn’t realize how off-balance I felt until things started getting better. After two weeks of taking Red Maca daily, I noticed fewer mood swings, less irritability, and better sleep. It’s like my body and emotions finally started syncing up again.'
        },
        {
            image: testimonial_image_3,
            testimony: '❤️ “Libido… Back! And It’s Not a Coincidence” Let’s be honest—stress and hormones can drain your spark. But Red Maca lit something back up in me. I feel more confident, more connected to my body, and yes, more interested in intimacy again. I wasn’t expecting it, but I’m loving it.'
        }
    ];

    return (
        <div className="testimonial-slider">
            <Swiper
                className='swiper-container'
                resizeObserver={true}
                spaceBetween={0}
                initialSlide={1}
                // init={false}
                speed={250}
                slideToClickedSlide={true}
                slidesPerView={1.7}
                loop={true}
                centeredSlides={true}
                breakpoints={{
                    0: {
                        direction: 'horizontal',
                    },
                    992: {
                        direction: 'vertical',
                    }
                }}
            >
                {
                    data.map((element, key) => {
                        return (
                            <SwiperSlide key={key}>
                                <div className="testimonial-slide">
                                    <div className="image">
                                        <div className="image-wrapper">
                                            <div className="image-inner">
                                                <img src={element.image} alt="testimony" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content">
                                        <p>{element.testimony}</p>
                                        <h5>— {element.name}</h5>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </div>
    );
};

export default TestimonialSlider;
